import { Flex } from '@mantine/core';
import { ReactComponent as FullLogoAr } from '../../assets/images/svg/jadwalh-logo-white-full.svg';
import { HeaderWrapper, MemberPhoto } from './styles';
import { useDispatch, useSelector } from 'react-redux';
import { IoMenuSharp, IoClose } from 'react-icons/io5';

import {
  closeSideMenu,
  getSideMenuState,
  openSideMenu,
} from '../../store/sideMenu.slice';
import { theme } from '@jadwalh/ui';
import { getProfileData } from '../../store/profile.slice';
import { AiOutlineUser } from 'react-icons/ai';
import { useNavigate, useLocation } from 'react-router-dom';
import { useIntl } from 'react-intl';
import { useState, useEffect } from 'react';
import useOutsideClick from '../../hooks/useOutsideClick';
import Cookies from 'js-cookie';
import { COOKIES_KEYS } from '../../app-constants/constants';
import { changLang, getLangState } from '../../store/lang.slice';
import { useMediaQuery } from '@mantine/hooks';
import { resetIntegrationId } from '../../store/zohoIntegrationId.slice';
import { getProfile } from '../../api/profile.api';
import { getPermissions } from '../../store/profile.slice';
import { getAuthToken, removeAuthToken, setAuthToken } from '../../utils/auth-token';

interface CookieOptions {
  path: string;
  sameSite: 'Lax' | 'Strict' | 'None';
  expires: Date;
  domain?: string;
  secure?: boolean;
}

export default function Header({ showLogo = true, login = false }) {
  const dispatch = useDispatch();
  const profile = useSelector(getProfileData);
  const navigate = useNavigate();
  const location = useLocation();
  const sideMenuState = useSelector(getSideMenuState);
  const [showUserActions, setShowUserActions] = useState(false);
  const { formatMessage } = useIntl();
  const ref = useOutsideClick(() => setShowUserActions(false));
  const lang = useSelector(getLangState);
  const permissions = useSelector(getPermissions);

  // Check if current route is plans, plans summary, subscription suspended, or deactivate clients
  const isRestrictedRoute = ['/plans', '/plans/summary', '/subscription-suspended', '/subscriptions/deactivate-clients'].includes(location.pathname);

  const getLangSelected = Cookies.get(COOKIES_KEYS.LanguageAdded);
  useEffect(() => {
    if (!getLangSelected || getLangSelected === 'undefined') return;
    dispatch(changLang({ lang: getLangSelected }));
  }, [getLangSelected]);
  useEffect(() => {
    const token = getAuthToken();
    if (token && token !== 'undefined') {
      // Ensure token is set in both localStorage and cookie
      setAuthToken(token);
      getProfile();
    }
  }, []);

  const logout = () => {
    localStorage.removeItem('email');
    localStorage.removeItem('isNew');
    removeAuthToken();

    // Clear sessionStorage on logout
    sessionStorage.clear();

    // remove zoho integration id from the store
    dispatch(resetIntegrationId());
    window.location.href = '/login';
  };

  const isMobile = useMediaQuery('(max-width: 768px)');

  return (
    <HeaderWrapper login={login}>
      <Flex justify={'space-between'} align={'center'} w={'100%'}>
        <Flex align={'center'}>
          {!isRestrictedRoute && (
            <button
              className="menu"
              title="open side menu"
              onClick={() =>
                dispatch(sideMenuState ? closeSideMenu() : openSideMenu())
              }
              style={{ width: '32px', height: '32px' }}
            >
              {sideMenuState ? (
                <IoClose color={theme.colours.AntiFlashWhite} size={24} />
              ) : (
                <IoMenuSharp color={theme.colours.AntiFlashWhite} size={24} />
              )}
            </button>
          )}
          <FullLogoAr
            className="large-screen"
            onClick={() => showLogo && navigate('/appointments')}
          />
        </Flex>
        <FullLogoAr
          className="small-screen noMarginTop"
          onClick={() => showLogo && navigate('/appointments')}
          style={{ cursor: 'pointer', marginLeft: '20px' }}
        />

        <div style={{ position: 'relative' }} ref={ref}>
          {showLogo &&
            (profile?.image ? (
              <MemberPhoto
                src={profile?.image}
                alt="member"
                onClick={() => setShowUserActions(!showUserActions)}
              />
            ) : (
              <AiOutlineUser
                color="white"
                className="default-photo"
                style={{ cursor: 'pointer' }}
                size={24}
                onClick={() => setShowUserActions(!showUserActions)}
              />
            ))}
          {showUserActions && (
            <Flex
              direction={'column'}
              gap={'8px'}
              px={'12px'}
              className="container-select"
            >
              {!isRestrictedRoute && (
                <>
                  <p
                    onClick={() => {
                      setShowUserActions(false);
                      navigate(isMobile ? '/profile' : '/settings/profile');
                    }}
                  >
                    {formatMessage({ id: 'profile' })}
                  </p>
                  <p
                    onClick={() => {
                      window.open('https://api.whatsapp.com/send?phone=966533501119', '_blank');
                      setShowUserActions(false);
                    }}
                  >
                    {formatMessage({ id: 'supportWhatsapp' })}
                  </p>
                  {/* <p
                    onClick={() => {
                      // TODO: Add the correct URL for submit request/report
                      window.open(
                        'https://help.jadwalh.com/hc/ar/requests/new',
                        '_blank'
                      );
                      setShowUserActions(false);
                    }}
                  >
                    {formatMessage({ id: 'submitRequest' })}
                  </p> */}
                  {/* <p
                    onClick={() => {
                      window.open('https://help.jadwalh.com/hc/ar', '_blank');
                      setShowUserActions(false);
                    }}
                  >
                    {formatMessage({ id: 'doYouNeedHelp' })}
                  </p> */}
                </>
              )}
              <p
                onClick={() => {
                  setShowUserActions(false);
                  logout();
                }}
              >
                {formatMessage({ id: 'Logout' })}
              </p>
            </Flex>
          )}
        </div>
      </Flex>
    </HeaderWrapper>
  );
}
